import React from "react";
import { bgColors, getTextEmotionColor, getEmotionColor } from "../utils";

const CustomTooltip2 = ({ active, payload, label, state }) => {
  if (
    !active ||
    !payload ||
    payload.length === 0 ||
    !state ||
    !state.tooltipCounts
  ) {
    return null;
  }
  const emotion = label;
  const tooltipData = state.tooltipCounts[emotion];

  const currentPercentage = payload[0]?.payload.currentPercent || 0;
  const comparePercentage = payload[1]?.payload.comparePercent || 0;
  const comparePeriod = state.chosenTimeCompare || "";

  if (!tooltipData || Object.keys(tooltipData).length === 0) {
    return (
      <div className="bg-white shadow-lg p-4 min-w-96 max-w-[300px]">
        <div
          className="text-sm mb-2 p-2 text-center"
          style={{ backgroundColor: bgColors[emotion] || "#888" }}
        >
          <div className="grid grid-cols-3 gap-1">
            <div className="font-semibold">Current</div>
            <div className="font-semibold">Prev {comparePeriod}</div>
            <div className="font-semibold">Change</div>

            <div className="font-bold">{currentPercentage}%</div>
            <div className="text-gray-400">{comparePercentage}%</div>
            <div
              className={`flex items-center justify-center gap-1 font-semibold ${getTextEmotionColor(
                emotion
              )}`}
            >
              {currentPercentage === comparePercentage ? (
                <span>–</span>
              ) : currentPercentage > comparePercentage ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 10l7-7 7 7M12 3v18"
                    />
                  </svg>
                  <span>
                    {Math.abs(currentPercentage - comparePercentage)}%
                  </span>
                </>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19 14l-7 7-7-7M12 3v18"
                    />
                  </svg>
                  <span>
                    {Math.abs(currentPercentage - comparePercentage)}%
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
        <p className="text-gray-500 italic">
          No student-specific data available for this emotion.
        </p>
      </div>
    );
  }

  const sortedStudents = Object.entries(tooltipData)
    .sort(([, a], [, b]) => b - a)
    .map(([email, count]) => ({
      name: state.studentEmailToNameMap?.[email] || email,
      count,
    }));

  return (
    <div className="bg-white shadow-lg p-3 min-w-64 max-w-[300px]">
      <div
        className="text-sm mb-2 p-2 text-center"
        style={{ backgroundColor: bgColors[emotion] || "#888" }}
      >
        <div className="grid grid-cols-3 gap-1">
          <div className="font-semibold">Current</div>
          <div className="font-semibold">Prev {comparePeriod}</div>
          <div className="font-semibold">Change</div>

          <div className="font-bold">{currentPercentage}%</div>
          <div className="text-gray-400">{comparePercentage}%</div>
          <div
            className={`flex items-center justify-center gap-1 font-semibold ${getTextEmotionColor(
              emotion
            )}`}
          >
            {currentPercentage === comparePercentage ? (
              <span>–</span>
            ) : currentPercentage > comparePercentage ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 10l7-7 7 7M12 3v18"
                  />
                </svg>
                <span>{Math.abs(currentPercentage - comparePercentage)}%</span>
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 14l-7 7-7-7M12 3v18"
                  />
                </svg>
                <span>{Math.abs(currentPercentage - comparePercentage)}%</span>
              </>
            )}
          </div>
        </div>
      </div>
      <h3 className="font-semibold text-sm text-700 py-2 pr-2">
        Students who've felt
        <span className={`ml-2 ${getTextEmotionColor(emotion)}`}>
          {emotion}
        </span>
      </h3>
      <div>
        {sortedStudents.length > 0 ? (
          <div className="max-h-40 overflow-y-auto">
            <table className="w-full text-left pt-2 text-sm text-400">
              <tbody className="divide-y divide-gray-100">
                {sortedStudents.map((student, i) => (
                  <tr
                    key={i}
                    className={`
                      ${i % 2 === 0 ? getEmotionColor(emotion) : "bg-white"}
                      hover:bg-gray-50
                    `}
                  >
                    <td className="p-2">{student.name}</td>
                    <td className="p-2 text-right">{student.count}x</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 italic">
            No student-specific data available.
          </p>
        )}
      </div>
    </div>
  );
};

export default CustomTooltip2;
